import { themedUseStyletron } from '../../../theme/customTheme'
import { IBacnetDevice } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { BacnetDeviceIcon } from './IconBacnetDevice';
import { InfoPanel } from './InfoPanel';


export function OverviewPanel(props: IBacnetDevice) {
    const [css, theme] = themedUseStyletron();
    const isOn = !props.noConnection;

    return (
        <OverviewPanelWrapper isOn={isOn} height={theme.appSizes.mediumAppHeight}  icon={<BacnetDeviceIcon color={theme.colors.backgroundPrimary} ></BacnetDeviceIcon>} {...props}>
            <InfoPanel {...props}></InfoPanel>
        </OverviewPanelWrapper>
    );
}